<template>
  <div class="main-page-modal-content">
    <div class="main-page-modal-content__head">
      <div class="main-page-modal-content__sort">
        <div>
          <h4 class="main-page-modal-content__sort-header">{{ $t('SORT_BY') }}:</h4>
          <a-radio-group
              :value="activeSort"
              @change="handleSortChange"
              class="main-page-modal-content__sort-buttons">
            <a-radio-button
                v-for="(sort, i) in listSort"
                :key="i"
                :value="sort.value"
                @click="changeSort(sort)"
                class="main-page-modal-content__sort-button">
              {{ $t(sort.label) }}
            </a-radio-button>
          </a-radio-group>
        </div>

        <div class="main-page-modal-content__sort_gallery-button">
          <span  @click="showGallery"><span v-if="notGallery"><a-icon type="picture" /></span><span v-else><a-icon type="profile" /></span></span>
        </div>
      </div>
    </div>
    <a-list
        class="main-page-modal-content__list"
        :itemLayout="listType"
        size="large"
        :pagination="pagination"
        :dataSource="monumentsList">
      <a-list-item
          class='main-page-modal-content__item'
          :class="{'main-page-content__item_full': !notGallery}"
          slot="renderItem"
          slot-scope="item"
          key="item.id"
          @click="openMonumentsModal(item.id)">
        <img
            :class="{'ant-list-objectFit': listType === 'horizontal'}"
            v-if="item.monument_photo && item.monument_photo.attachment"
            slot="extra"
            :height="listType === 'vertical' ? '150' : ''"
            :src="'https://oooak.org/'+ item.monument_photo.attachment.medium.url"/>
        <img
            :class="{'ant-list-objectFit': listType === 'horizontal'}"
            v-if="item.monument_photo == null"
            slot="extra"
            :height="listType === 'vertical' ? '150' : ''"
            class='main-page-modal-content__img-empty'
            src="@/assets/img/cemetery.svg"/>
        <div class="main-page-modal-content__info" v-if="notGallery">
          <div class="main-page-modal-content__title" v-if="listType === 'vertical'">
            <strong v-if="item.full_name">{{ item.full_name }}</strong>
            <strong v-else>{{ $t('UNKNOWN_NAME') }}</strong>
          </div>
          <div v-if="listType === 'vertical'">
            <strong>{{ $t('LOCATION') }}:</strong>
            <div v-if="item.burial_city || item.burial_country || item.cemetary_name">
              <span v-if="item.burial_country">{{ item.burial_country }}</span>
              <span v-if="item.burial_city">, {{ item.burial_city }}</span>
              <span v-if="item.cemetary_name">, {{ item.cemetary_name }}</span>
            </div>
            <span v-else>{{ $t('UNKNOWN') }}</span>
          </div>
          <div v-if="listType === 'vertical'">
            <strong>{{ $t('CATEGORIES') }}: </strong>
            <div v-if="item.categories.length" class="main-page-content__categories">
              <span v-for="(category, key) in item.categories" :key="key">{{ category.name }}</span>
            </div>
            <span v-else>{{ $t('UNKNOWN') }}</span>
          </div>
          <div v-if="listType === 'vertical'">
            <strong>{{ $t('DATE_OF_BIRTH') }}: </strong>
            <span v-if="item.birth_date && /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(item.birth_date)">
              {{ item.birth_date }}
            </span>
            <span v-else-if="!item.birth_date">{{ $t('UNKNOWN') }}</span>
            <span v-else>
              {{ dateFns.format(item.birth_date, consts.formatDate, {locale: locales[$store.getters.getLocale]}) }}
            </span>
          </div>
          <div v-if="listType === 'vertical'">
            <strong>{{ $t('DATE_OF_DEATH') }}: </strong>
            <span v-if="item.death_date && /^\d{1,2}\.\d{1,2}\.\d{4}$/.test(item.death_date)">
              {{ item.death_date }}
            </span>
            <span v-else-if="!item.death_date">{{ $t('UNKNOWN') }}</span>
            <span v-else>
              {{ dateFns.format(item.death_date, consts.formatDate, {locale: locales[$store.getters.getLocale]}) }}
            </span>
          </div>
        </div>
        <template slot="actions">
          <span
              @click.stop="deleteLike(item, user)" :class="{'changePosition': listType === 'horizontal'}">
            {{item.likes.length}}
            <a-icon
                type="heart"
                style="margin-right: 8px;"
                :theme="item.likes.find(x => x.user_id == user.id) ? 'filled' : 'outlined'"/>
          </span>
        </template>
      </a-list-item>
    </a-list>
    <!--Модальное окно памятника-->
    <monuments-modal/>
  </div>
</template>

<script>
import BaseComponent from '@/components/extends/BaseComponent'
import {mapMutations, mapActions, mapGetters} from 'vuex'
import {paramInURLToggle} from '@/services/http'
import monumentsModal from '@/components/monuments/item/modal'

export default {
name: "MonumentListContent",
  extends: BaseComponent,
  components: {
    [monumentsModal.name]: monumentsModal
  },
  data() {
    return {
      listSort: [
        {
          label: 'POPULARITY',
          value: 'likes.length'
        },
        {
          label: 'AGE',
          value: 'death_date'
        },
        {
          label: 'ALPHABET',
          value: 'first_name'
        },
      ],
      activeSort: '',
      listData: [],
      listType: 'vertical',
    };
  },
  computed: {
    ...mapGetters({
      notGallery: 'cemeteries/getGallery',
      monumentsList: 'monuments/getMonumentsList',
      isAuth: 'user/isAuth',
      getTotalCount: 'monuments/getTotalCount',
      user: 'user/getUser',
      filterBody: 'monuments/getFilterBody',
    }),
    pagination() {
      return {
        onChange: page => {
          this.changeFilterBody({title: 'page', value: page});
          document.getElementsByClassName('ant-spin-container')[1].scrollTo({
            top: 0,
            behavior: 'smooth'
          })
        },
        pageSize: 20,
        total: this.getTotalCount,
        size: 'small'
      }
    },
  },
  methods: {
    ...mapActions({
      initList: 'monuments/getMonumentsList',
      deleteMonumentLike: 'monuments/deleteMonumentLike',
      initFilteredList: 'monuments/getFilteredMonuments',
      initListCount: 'cemeteries/getCemeteriesListCount',
      like: 'monuments/monumentLike',
      getMonumentsToMap: 'monuments/getMonumentsListToMap',
      showGallery: 'cemeteries/showGallery',
    }),
    ...mapMutations({
      changeFilterBody: 'monuments/CHANGE_FILTER_BODY'
    }),

    deleteLike(item, user) {
      let userLike =  item.likes.find(x => x.user_id == user.id)
      if (userLike){
        this.deleteMonumentLike(userLike)
      } else {
        this.monumentLike(item.id, user.id)
      }
    },

    changeSort(sort) {
      this.changeFilterBody({title: 'selected_sort', value: sort.value});
      this.initList(this.filterBody);
    },

    async init() {
      await this.initList(this.filterBody);
    },

    monumentLike(itemId, userId) {
      if (this.isAuth) {
        this.like({
          user_id: userId,
          post_entity_id: itemId,
          post_entity_type: "Monument"
        })
      } else {
        this.authModalToggle(this.$t('SIGN_IN_TO_LIKE'))
      }
    },
    listSortTypeToggle() {
      this.listSortType === 'asc' ? this.listSortType = 'desc' : this.listSortType = 'asc'
    },
    listTypeToggle() {
      this.listType === 'horizontal' ? this.listType = 'vertical' : this.listType = 'horizontal'
    },
    openMonumentsModal(monumentId) {
      paramInURLToggle('id', monumentId);
    },
    handleSortChange(e) {
      this.activeSort = e.target.value;
    },
  },

  created() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.main-page-modal-content {
  .ant-list-item {
    margin-right: 0;
  }
  &__sort {
    position: relative;
    display: flex;
    padding: 20px 10px 5px;
    &_gallery-button {
      position: absolute;
      z-index: 71;
      bottom: 0;
      right: 10px;
      font-size: 25px;
      color: #A3A3A3;
    }
  }
  .ant-list-item-extra {
    & img {
      max-height: none;
      max-width: none;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
</style>
